export const getExpiryDate = (timeStr) => {
    const currentDate = new Date();
    const unit = timeStr[timeStr.length - 1];
    const num = parseInt(timeStr.substring(0, timeStr.length - 1));
    let expiryTime;

    if (unit === "s") {
        expiryTime = currentDate.getTime() + (num * 1000); // num seconds
    } else if (unit === "m") {
        expiryTime = currentDate.getTime() + (num * 60 * 1000); // num minutes
    } else if (unit === "h") {
        expiryTime = currentDate.getTime() + (num * 60 * 60 * 1000); // num hours
    } else if (unit === "d") {
        expiryTime = currentDate.getTime() + (num * 24 * 60 * 60 * 1000); // num days
    } else {
        throw new Error("Invalid time unit");
    }

    return new Date(expiryTime);
};

export const setCookie = (name, value, expiry) => {
    const expires = getExpiryDate(expiry);
    const cookieOptions = [
        `${name}=${value}`,
        `expires=${expires.toUTCString()}`,
        'path=/',
        'secure', // Include 'secure' attribute for secure connections (HTTPS)
        'samesite=none', // Include 'samesite' attribute for strict same-site enforcement
        'readonly', // Include 'readonly' attribute to prevent modification by JavaScript
    ].join('; ');

    document.cookie = cookieOptions;
};

export const getCookie = (name) => {
    const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return cookieValue ? cookieValue[2] : null;
};

export const deleteCookie = (name) => {
    const cookieOptions = [
        `${name}=`,
        `expires=${new Date(0).toUTCString()}`, // Set the expiration date to a past date
        'path=/',
        'secure', // Include 'secure' attribute for secure connections (HTTPS)
        'samesite=none', // Include 'samesite' attribute for strict same-site enforcement
        'readonly', // Include 'readonly' attribute to prevent modification by JavaScript
    ].join('; ');
    document.cookie = cookieOptions;
};